import Vue from 'vue'
import Page from '@/components/pdf-pages/invoice-8'
import injectedCss from '!!raw-loader!@/components/pdf-pages/css/invoice.css'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateInvoice8 = async ({ invoice, rfq, rfq3s, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :invoice="invoice" :rfq="rfq" :rfq3s="rfq3s" :content="content"/>`,
      components: {
        'page': Page
      },
      data: () => ({
        invoice,
        rfq,
        rfq3s,
        content
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss, injectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
